module.exports = __webpack_public_path__ + "static/media/fastrewind01.f37f0a95.svg";